import { client } from '../api';
import { PAYMENT_V3_URL, DEFAULT } from './constants';

export const get = (customerId, id) =>
  client.get(PAYMENT_V3_URL(customerId) + id);

export const getDefault = customerId =>
  client.get(PAYMENT_V3_URL(customerId) + DEFAULT);

export const create = (customerId, paymentMethod) =>
  client.post(PAYMENT_V3_URL(customerId), paymentMethod);

export const update = (customerId, paymentId, paymentMethod) =>
  client.patch(`${PAYMENT_V3_URL(customerId)}${paymentId}/`, paymentMethod);
